<template>
    <div class="payment-information" ref="paymentInformation">
        <slot name="title">
            <div v-if="showTitle" class="row">
                <div class="col-sm-12">
                    <h3 class="text-left account-title">
                        Payment Information
                    </h3>
                </div>
                <div class="col-md-12" v-if="!editMode">
                  <h3 class="text-left text-normal margin-bottom-20 col-md-6 col-sm-6 margin-top-0 account-subtitle" :class="{'col-xs-12' : editMode, 'col-xs-9' : !editMode}"> Update your Payment Information </h3>
                  <div class="col-md-6 col-sm-6 col-xs-3 text-right" >
                      <div class="row edit-row">
                          <img src="/dist/site/static/icons/edit.svg" class="edit-icon" alt="Edit">		
                          <a href="#"  @click.prevent="toggleEditMode()" class="edit-text">
                              Edit 
                          </a>
                      </div>
                  </div>
                </div>
                <div class="col-sm-12"  v-if="errors.has('stripeErrors')">
                    <div class="invalid-feedback-red">
                        {{errors.get('stripeErrors')}}
                    </div>
                </div>
                <div class="col-sm-12"  v-if="customError">
                    <div class="invalid-feedback-red">
                        {{customError}}
                    </div>
                </div>
                <div class="col-sm-12" v-if="editMode || showInternalErrorMessage">
                    <div class="text-left text-danger margin-bottom-20" v-if="errors.has('internalError') || errors.has('addProcessingFees')">
                        There was an error processing your payment information. Please try again later.
                    </div>
                </div>
            </div>
        </slot>
        <div v-if="!editMode" class="margin-top-20 margin-bottom-20">
            <div class="row">
                <div class="col-sm-12">
                 <label class="hh-input-label">Card Number</label>
                    <div v-if="userData.last4">
                        <div class="form-control padding-top-10 card-number-wrapper" v-if="userData.last4">
                            <div class="card-number-stripe">
                                {{`**** ${userData.last4}`}}
                            </div>
                            <div class="card-number-icon" v-if="userData.brand === 'Visa'">
                                <img src="/dist/site/static/icons/visa.svg" class="center-block" alt="Visa">
                            </div>
                            <div class="card-number-icon" v-if="userData.brand === 'MasterCard'">
                                <img src="/dist/site/static/icons/mastercard.svg" class="center-block mastercard-img" alt="Mastercard">
                            </div>
                        </div>
                    </div>
                    <div class="form-group" v-else>
                        <span class="form-control overflow-x form-color">
                            Unavailable
                        </span>
                    </div>
                </div>
            </div>
        </div>
        <div v-show="editMode" class="margin-top-20 margin-bottom-20">
            <div v-if="isGuest">
                <div class="row">
                    <div class="form-group col-sm-12">
                        <input-label type="text" css-class="form-control" required v-model="userData.email"
                                     placeholder="Email address" autocomplete="cc-name"/>
                        <div ref="nameError">
                            <div class="invalid-feedback-red" v-if="errors.has('email')">
                                {{errors.get('email')}}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="form-group col-sm-6">
                        <input-label type="text" css-class="form-control" required v-model="userData.first_name"
                                     placeholder="First name" autocomplete="cc-name"/>
                        <div ref="nameError">
                            <div class="invalid-feedback-red" v-if="errors.has('first_name')">
                                {{errors.get('first_name')}}
                            </div>
                        </div>
                    </div>
                    <div class="form-group col-sm-6">
                        <input-label type="text" css-class="form-control" required v-model="userData.last_name"
                                     placeholder="Last name" autocomplete="cc-name"/>
                        <div ref="nameError">
                            <div class="invalid-feedback-red" v-if="errors.has('last_name')">
                                {{errors.get('last_name')}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row margin-bottom-20">
                <div class="col-sm-5">
                    <h6 class="text-normal hh-gray-semi-light">Use credit or debit card</h6>
                </div>
                <div class="col-sm-7 payment-icon-wrapper">
                    <img src="/dist/site/static/icons/card-visa-2.svg?v=1.0.1" class="payment-icon" alt="Visa">
                    <img src="/dist/site/static/icons/card-discover-2.svg?v=1.0.1" class="payment-icon" alt="Discover">
                    <img src="/dist/site/static/icons/card-mastercard-2.svg?v=1.0.1" class="payment-icon" alt="Mastercard">
                    <img src="/dist/site/static/icons/card-amex-2.svg?v=1.0.1" class="payment-icon" alt="AMEX">
                </div>
            </div>
            <div class="row">
                <div class="form-group col-sm-12">
                    <input-label type="text" css-class="form-control" v-model="userData.name"
                           placeholder="Name on card" autocomplete="cc-name" />
                    <div ref="nameError">
                        <div class="invalid-feedback-red" v-if="formErrors.name">
                            {{formErrors.name}}
                        </div>
                        <div class="invalid-feedback-red" v-if="isGuest && errors.has('name')">
                            {{errors.get('name')}}
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="form-group col-sm-12">
                  <label for="stripe-card-number" class="hh-input-label">Card number</label>
                    <div class="form-control padding-top-10 card-number-wrapper hh-input-label-wrapper">
                        <div ref="card_number" id="stripe-card-number" class="stripe-element card-number-stripe">
                            <!-- A Stripe Element will be inserted here. -->
                        </div>
                    </div>
                    <div ref="cardNumberError">
                        <div class="invalid-feedback-red" v-if="formErrors.cardNumber">
                            {{formErrors.cardNumber}}
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="form-group col-sm-6">
                  <label for="stripe-exp-date" class="hh-input-label">Exp. date</label>
                    <div class="form-control padding-top-10 hh-input-label-wrapper">
                        <div id="stripe-exp-date" ref="expiration_date" class="stripe-element">
                            <!-- A Stripe Element will be inserted here. -->
                        </div>
                    </div>
                    <div ref="expireDateError">
                        <div class="invalid-feedback-red" v-if="formErrors.expireDate">
                            {{formErrors.expireDate}}
                        </div>
                    </div>
                </div>
                <div class="form-group col-sm-6">
                  <label for="stripe-cvc" class="hh-input-label">CVC</label>
                  <div class="form-control padding-top-10 hh-input-label-wrapper">
                      <div id="stripe-cvc" ref="cvc" class="stripe-element">
                          <!-- A Stripe Element will be inserted here. -->
                      </div>
                  </div>
                  <div ref="cvcError">
                      <div class="invalid-feedback-red" v-if="formErrors.cvc">
                          {{formErrors.cvc}}
                      </div>
                  </div>
                </div>
            </div>
          
        </div>
    </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import InputLabel from './elements/InputLabel'
  import { loadStripe } from '@stripe/stripe-js';
  import {scrollTo} from '../../utils/componentHelper'

  export default {
    name: 'PaymentInformation',

    components: {
      InputLabel
    },

    props: {
      userData: {
        email: String,
        name: String,
        last4: String,
        brand: String,
      },
      stripeKey: String,
      showInternalErrorMessage: Boolean,
      isGuest: {
          type: Boolean,
          default: false
      },
      editMode: Boolean,
      showTitle: Boolean,
      showSaveCardCheckbox: Boolean,
      errors: Object,
      editInformationRouteName: String,
    },

    data: () => {
      return {
        loading: false,
        saveCard: false,
        customError: null,
        formErrors: {
          cardNumber: null,
          name: null,
          cvc: null,
          expireDate: null,
        },
        stripeElements: {
          cardNumber: null,
          expireDate: null,
          cvc: null,
        },
        stripe: null,
        stripeError: null,
        stripeIsComplete: {
          cardNumber: false,
          cvc: false,
          expireDate: false,
        },
        stripeIsEmpty: {
          cardNumber: true,
          cvc: true,
          expireDate: true,
        },
      }
    },

    beforeMount () {
      if (_.isEmpty(this.stripeKey)) {
        console.error('Stripe key is missing')
        return
      }
      loadStripe(this.stripeKey).then( (stripe) => this.initStripe(stripe) );
    },

    methods: {
      initStripe (stripe) {
          this.stripe = stripe
        let elements = this.stripe.elements({
          fonts: [
            {
              cssSrc: 'https://fonts.googleapis.com/css?family=Montserrat:500',
            }
          ]
        })

        let elementStyles = {
          base: {
            color: '#666666',
            fontSize: '16px',
            fontFamily: 'Montserrat',
            fontSmoothing: 'antialiased',
            '::placeholder': {
              color: '#B2B8B7',
            },
          },
          invalid: {
            color: 'rgb(188, 46, 46)',

            '::placeholder': {
              color: 'rgb(188, 46, 46)',
            },
          },
        }
        let elementClasses = {
          complete: 'hh-label-active',
          focus: 'focused hh-label-active',
          empty: 'empty',
          invalid: 'invalid hh-label-active',
        }

        this.stripeElements.cardNumber = elements.create('cardNumber', {
          style: elementStyles,
          classes: elementClasses,
          placeholder: '4242 4242 4242 4242',
          showIcon: true
        })

        this.stripeElements.cardNumber.mount(this.$refs.card_number)

        this.stripeElements.expireDate = elements.create('cardExpiry', {
          style: elementStyles,
          classes: elementClasses,
          placeholder: 'MM/YY'
        })
        this.stripeElements.expireDate.mount(this.$refs.expiration_date)

        this.stripeElements.cvc = elements.create('cardCvc', {
          style: elementStyles,
          classes: elementClasses,
          placeholder: 'Enter CVC'
        })
        this.stripeElements.cvc.mount(this.$refs.cvc)

        let elementsCount = _.size(this.stripeElements)

        for (let element in this.stripeElements) {
          this.stripeElements[element].addEventListener('change', (event) => {
            if (!_.isEmpty(event.error)) {
              this.formErrors[element] = event.error.message
            } else {
              this.formErrors[element] = null
            }
            this.stripeIsComplete[element] = event.complete
            this.stripeIsEmpty[element] = event.empty
          })

          this.stripeElements[element].addEventListener('ready', () => {
            elementsCount--
            if (elementsCount < 1) {
              this.$emit('componentLoading', this.$options.name, false)
            }
          })
        }
      },

      shouldSubmit () {
        for (let element in this.stripeIsEmpty) {
          if (!this.stripeIsEmpty[element]) {
            return true
          }
        }

        return false
      },

      canSubmit () {
        if (_.isEmpty(this.userData.name)) {
          this.formErrors.name = 'Name field is required'
          return false
        }

        let stripeValidation  = true
        for (let element in this.stripeIsComplete) {
          if (!this.stripeIsComplete[element]) {
            this.formErrors[element] = 'This field is required'
            stripeValidation = false
          }
        }

        return stripeValidation
      },

      async submitForm () {
        this.stripeError = null;
        this.customError = null;

        return this.stripe.createToken(this.stripeElements.cardNumber, {
          name: this.userData.name
        }).then((result) => {
          if (result.error) {
            this.stripeError = result.error.message
            this.userData.token = null
            this.userData.last4 = null
            return false
          } else {
            this.userData.token = result.token.id
            this.userData.last4 = result.token.card.last4
            return true
          }
        })
      },

      confirmCardPayment (billingData, checkoutData, userInformation) {
          let paymentMethod = checkoutData.paymentMethodId
          this.customError = null

          if (checkoutData.paymentMethodId == null || this.editMode) {
            paymentMethod = {
                card: this.stripeElements.cardNumber,
                // name: this.userData.name,
                billing_details: {
                    // name: `${billingData.billing_first_name} ${billingData.billing_last_name}`,
                    name: userInformation.name,
                    address: {
                        city: billingData.billing_city,
                        country: 'US',
                        line1: billingData.billing_address_1,
                        line2: billingData.billing_address_2,
                        postal_code: billingData.billing_zip,
                        state: billingData.billing_state,
                    },
                }
            }
        }

        let options = {
            payment_method: paymentMethod,
            receipt_email: userInformation.email,
        }

         // if (checkoutData.paymentMethodId == null && this.saveCard) {
         //     options.setup_future_usage = 'on_session'
         // }

        return this.stripe.confirmCardPayment(checkoutData.paymentIntentClientSecret, options).then((result) => {
            if (result.error) {
                this.customError = result.error.message
                this.userData.token = null
                this.userData.last4 = null
                return false
            }

            return result.paymentIntent.status === 'succeeded';
        });
      },

      toggleEditMode () {
        if (this.editInformationRouteName) {
          this.$router.push({name: this.editInformationRouteName})
          return true
        }
        this.$emit('toggleEditMode')
      },
    },

    computed: {
      ...mapGetters({
        authUser: 'authUser',
      }),
      hasErrors () {
        for (let error in this.formErrors) {
          if (this.formErrors[error]) {
            return true
          }
        }
        return false
      },
    },

    watch: {
      hasErrors (to, from) {
        this.$emit('setPaymentFormState', !to)
      },
      userData: {
        handler (to, from) {
          if (!_.isEmpty(to)) {
            this.formErrors.name = null
          }
        },
        deep: true
      },

    }
  }
</script>

<style lang="scss" scoped>
    .payment-icon-wrapper {
        display: inline-flex;
        justify-content: flex-end;
    }

    .payment-icon {
        width: 50px;
        height: 30px;
        border-radius: 10%;

        display: flex;
        justify-content: center;
        align-items: center;

        margin-right: 5px;
    }
    
    .hh-input-label-wrapper {
      height: 55px;
    }

    .stripe-element {
        margin-top: -3px;
    }

    .form-control.overflow-x {
      height: 55px;
      padding: 12px;
      display: flex;
      align-items: center;
    }
</style>